"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var middleware_stack_1 = require("@aws-sdk/middleware-stack");

var Client =
/** @class */
function () {
  function Client(config) {
    this.middlewareStack = new middleware_stack_1.MiddlewareStack();
    this.config = config;
  }

  Client.prototype.send = function (command, optionsOrCb, cb) {
    var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
    var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
    var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);

    if (callback) {
      handler(command).then(function (result) {
        return callback(null, result.output);
      }, function (err) {
        return callback(err);
      }).catch( // prevent any errors thrown in the callback from triggering an
      // unhandled promise rejection
      function () {});
    } else {
      return handler(command).then(function (result) {
        return result.output;
      });
    }
  };

  return Client;
}();

exports.Client = Client;